import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface SystemOverview {
	orders: {
		total: number;
		paid: number;
		pending: number;
		expired: number;
		cancelled: number;
	};
	platform: {
		activeUsers: number;
		activeMerchants: number;
	};
	recentActivity: {
		last24Hours: number;
		last7Days: number;
		last30Days: number;
	};
	revenue: {
		totalUsdCents: number;
		totalUsd: string;
	};
}

export interface ProfitDataPoint {
	date: string;
	volume: number;
	profit: number;
	profitMargin: number;
}

export interface ProfitCurrencyBreakdown {
	currency: string;
	totalVolume: number;
	totalProfit: number;
	profitMargin: number;
	volumeChangePct: number;
	profitChangePct: number;
	marginChangePct: number;
	series: ProfitDataPoint[];
}

export interface ProfitAnalyticsPeriod {
	currentStart: string;
	currentEnd: string;
	previousStart: string;
	previousEnd: string;
}

export interface ProfitAnalyticsResponse {
	period: ProfitAnalyticsPeriod;
	currencies: ProfitCurrencyBreakdown[];
}

export interface OrderStatusDataPoint {
	date: string;
	paid: number;
	pending: number;
	expired: number;
	cancelled: number;
}

export interface OrderStatusAnalyticsResponse {
	period: ProfitAnalyticsPeriod;
	series: OrderStatusDataPoint[];
}

const analyticsProvider = {
	async getSystemOverview(): Promise<SystemOverview> {
		const response = await apiRequest.get(withApiPath("/analytics/overview"));
		return response.data;
	},
	async getProfitAnalytics(
		startDate: string,
		endDate: string,
	): Promise<ProfitAnalyticsResponse> {
		const response = await apiRequest.get(withApiPath("/analytics/profit"), {
			params: {
				start_date: startDate,
				end_date: endDate,
			},
		});
		return response.data;
	},
	async getOrderStatusAnalytics(
		startDate: string,
		endDate: string,
	): Promise<OrderStatusAnalyticsResponse> {
		const response = await apiRequest.get(
			withApiPath("/analytics/order-status"),
			{
				params: {
					start_date: startDate,
					end_date: endDate,
				},
			},
		);
		return response.data;
	},
};

export default analyticsProvider;
